// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.user-guide-layout {
  display: flex;
  min-height: 70vh;
  background: #f4f6f9;
}

.user-guide-sidebar {
  display: flex;
  flex: 0 0 260px;
  flex-direction: column;
  background: #1e2a3a;
  color: #d6e0ed;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.18);
}

.sidebar-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 12px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.2);
}

.sidebar-header-icon {
  color: #6fb3f5;
  flex: 0 0 auto;
}

.sidebar-header-title {
  overflow: hidden;
  color: #fff;
  font-size: 0.85rem;
  font-weight: 700;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
}

.sidebar-nav {
  flex: 1;
  overflow: auto;
  padding: 8px 0;
}

.sidebar-nav-item {
  display: flex;
  width: 100%;
  align-items: center;
  padding: 11px 14px;
  border: 0;
  border-left: 3px solid transparent;
  background: transparent;
  color: #d6e0ed;
  cursor: pointer;
  text-align: left;
  transition: background 0.2s ease, color 0.2s ease;
}

.sidebar-nav-item:hover {
  background: rgba(255, 255, 255, 0.07);
  color: #fff;
}

.sidebar-nav-item.active {
  border-left-color: #0055b3;
  background: rgba(0, 85, 179, 0.35);
  color: #fff;
}

.sidebar-nav-label {
  overflow: hidden;
  font-size: 0.875rem;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-guide-content {
  flex: 1;
  min-width: 0;
  padding: 32px 40px;
}

.content-loading {
  display: flex;
  min-height: 200px;
  align-items: center;
  justify-content: center;
}

.guide-error {
  color: #a12622;
}

:host ::ng-deep .content-body.markdown-body {
  width: 100%;
  box-sizing: border-box;
  padding: 36px 40px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
}

:host ::ng-deep .markdown-body h1,
:host ::ng-deep .markdown-body h2,
:host ::ng-deep .markdown-body h3 {
  color: #1e2a3a;
}

:host ::ng-deep .markdown-body h1 {
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e4e9f0;
  font-size: 1.65rem;
}

:host ::ng-deep .markdown-body h2 {
  margin-top: 1.75rem;
  font-size: 1.25rem;
}

:host ::ng-deep .markdown-body p,
:host ::ng-deep .markdown-body li {
  color: #3d4f65;
  font-size: 0.95rem;
  line-height: 1.7;
}

:host ::ng-deep .markdown-body a {
  color: #0055b3;
  text-decoration: none;
}

:host ::ng-deep .markdown-body a:hover {
  text-decoration: underline;
}

:host ::ng-deep .markdown-body img {
  display: block;
  width: auto;
  max-width: 100%;
  height: auto;
  margin: 1rem 0;
  border-radius: 6px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
}

:host ::ng-deep .markdown-body pre,
:host ::ng-deep .markdown-body code {
  background: #f0f4f8;
}

:host ::ng-deep .markdown-body pre {
  overflow-x: auto;
  padding: 14px 18px;
  border-radius: 6px;
}

:host ::ng-deep .markdown-body blockquote {
  margin: 1rem 0;
  padding: 8px 16px;
  border-left: 4px solid #0055b3;
  background: #f0f6ff;
}

@media (max-width: 768px) {
  .user-guide-layout {
    flex-direction: column;
  }

  .user-guide-sidebar {
    flex-basis: auto;
  }

  .sidebar-nav {
    display: flex;
    max-height: 180px;
    flex-flow: row wrap;
  }

  .sidebar-nav-item {
    width: auto;
    max-width: 50%;
    flex: 1 1 180px;
  }

  .user-guide-content {
    padding: 20px 16px;
  }

  :host ::ng-deep .content-body.markdown-body {
    padding: 20px 18px;
  }
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/user-guide/user-guide.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,iDAAiD;EACjD,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,kCAAkC;EAClC,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[":host {\n  display: block;\n}\n\n.user-guide-layout {\n  display: flex;\n  min-height: 70vh;\n  background: #f4f6f9;\n}\n\n.user-guide-sidebar {\n  display: flex;\n  flex: 0 0 260px;\n  flex-direction: column;\n  background: #1e2a3a;\n  color: #d6e0ed;\n  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.18);\n}\n\n.sidebar-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 18px 12px 14px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.sidebar-header-icon {\n  color: #6fb3f5;\n  flex: 0 0 auto;\n}\n\n.sidebar-header-title {\n  overflow: hidden;\n  color: #fff;\n  font-size: 0.85rem;\n  font-weight: 700;\n  text-overflow: ellipsis;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.sidebar-nav {\n  flex: 1;\n  overflow: auto;\n  padding: 8px 0;\n}\n\n.sidebar-nav-item {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  padding: 11px 14px;\n  border: 0;\n  border-left: 3px solid transparent;\n  background: transparent;\n  color: #d6e0ed;\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.sidebar-nav-item:hover {\n  background: rgba(255, 255, 255, 0.07);\n  color: #fff;\n}\n\n.sidebar-nav-item.active {\n  border-left-color: #0055b3;\n  background: rgba(0, 85, 179, 0.35);\n  color: #fff;\n}\n\n.sidebar-nav-label {\n  overflow: hidden;\n  font-size: 0.875rem;\n  line-height: 1.35;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.user-guide-content {\n  flex: 1;\n  min-width: 0;\n  padding: 32px 40px;\n}\n\n.content-loading {\n  display: flex;\n  min-height: 200px;\n  align-items: center;\n  justify-content: center;\n}\n\n.guide-error {\n  color: #a12622;\n}\n\n:host ::ng-deep .content-body.markdown-body {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 36px 40px;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);\n}\n\n:host ::ng-deep .markdown-body h1,\n:host ::ng-deep .markdown-body h2,\n:host ::ng-deep .markdown-body h3 {\n  color: #1e2a3a;\n}\n\n:host ::ng-deep .markdown-body h1 {\n  padding-bottom: 0.5rem;\n  border-bottom: 2px solid #e4e9f0;\n  font-size: 1.65rem;\n}\n\n:host ::ng-deep .markdown-body h2 {\n  margin-top: 1.75rem;\n  font-size: 1.25rem;\n}\n\n:host ::ng-deep .markdown-body p,\n:host ::ng-deep .markdown-body li {\n  color: #3d4f65;\n  font-size: 0.95rem;\n  line-height: 1.7;\n}\n\n:host ::ng-deep .markdown-body a {\n  color: #0055b3;\n  text-decoration: none;\n}\n\n:host ::ng-deep .markdown-body a:hover {\n  text-decoration: underline;\n}\n\n:host ::ng-deep .markdown-body img {\n  display: block;\n  width: auto;\n  max-width: 100%;\n  height: auto;\n  margin: 1rem 0;\n  border-radius: 6px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);\n}\n\n:host ::ng-deep .markdown-body pre,\n:host ::ng-deep .markdown-body code {\n  background: #f0f4f8;\n}\n\n:host ::ng-deep .markdown-body pre {\n  overflow-x: auto;\n  padding: 14px 18px;\n  border-radius: 6px;\n}\n\n:host ::ng-deep .markdown-body blockquote {\n  margin: 1rem 0;\n  padding: 8px 16px;\n  border-left: 4px solid #0055b3;\n  background: #f0f6ff;\n}\n\n@media (max-width: 768px) {\n  .user-guide-layout {\n    flex-direction: column;\n  }\n\n  .user-guide-sidebar {\n    flex-basis: auto;\n  }\n\n  .sidebar-nav {\n    display: flex;\n    max-height: 180px;\n    flex-flow: row wrap;\n  }\n\n  .sidebar-nav-item {\n    width: auto;\n    max-width: 50%;\n    flex: 1 1 180px;\n  }\n\n  .user-guide-content {\n    padding: 20px 16px;\n  }\n\n  :host ::ng-deep .content-body.markdown-body {\n    padding: 20px 18px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
